<div class="row justify-content-center faqMainDiv">
  <div class="col-md-9">
    <div class="row faqDiv">

      <div class="col-md-2 d-flex justify-content-end align-items-center">
        <img src="../../../assets/img/customer/faq.png" width="75px">
      </div>
      <div class="col-md-10">
        <div class="askedDiv">
          <h3>Frequently Asked Questions</h3>
          <p class="mt-3">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. as opposed to using 'Content here, content here', making it look like readable English.</p>
        </div>
      </div>

      <div class="col-12">

        <p class="mt-5 pTag">Getting Started</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>How is Arrivae different from traditional design companies ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>What kind of spaces can Arrivae design ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>Can I use Arrivae if don't live in one of your cities ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

        <p class="mt-5 pTag">Our Designers</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

        <p class="mt-5 pTag">I have a designer, now what ?</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>What kind of spaces can Arrivae design ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>Can I use Arrivae if don't live in one of your cities ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

        <p class="mt-5 pTag">The ins & outs of booking your project ?</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>Can I use Arrivae if don't live in one of your cities ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

        <p class="mt-5 pTag">The Concierge</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>How is Arrivae different from traditional design companies ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>What kind of spaces can Arrivae design ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>Can I use Arrivae if don't live in one of your cities ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

        <p class="mt-5 pTag">I have a problem</p>
        <div class="GettingDiv topBorder">
          <h5>Why should I use Arrivae ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>How is Arrivae different from traditional design companies ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>What kind of spaces can Arrivae design ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv">
          <h5>Can I use Arrivae if don't live in one of your cities ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>
        <div class="GettingDiv bottomBorder">
          <h5>How does Arrivae focus on designer-client partnerships ?</h5>
          <p class="mb-0">It is a long established fact that a reader will be distracted by the readable content of a fact that a reader will be distracted by the readable content of a page when looking at its layout.</p>
        </div>

      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/customer/faq/faq.component.html